<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <div :style="getColorIconStyle(model)"></div>
      <v-text-field v-model="model" class="schema-name-input" label="Kolor" v-on="on"></v-text-field>
    </template>

    <v-container style="background-color: #ffffff">
      <color-picker v-bind="color" @input="(hue) => onInput(hue, hex => model = hex)"></color-picker>
    </v-container>
  </v-menu>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker'

export default {
  props:['value'],
  name: "CalendarData",
  components: {ColorPicker},
  mixins: [Color],
  created() {
    this.model = this.value
  },
  data() {
    return {
      model: null,
    }
  },
  watch:{
    model:function(newVal){
      this.$emit('input', newVal)
    },
    value:function(newVal){ //todod
      if(this.model != newVal){
        this.model = newVal
      }
    }
  }
}
</script>

<style scoped>

</style>